@if (userAndCardDetails$ | async; as userAndCardDetails) {
  <div>
    @if (userAndCardDetails[0]; as paymentDetails) {
      <h1 class="bottom-sheet-title">{{'existing-card.Secure' | translate}}</h1>
      <!-- <p class="mode-description txt-clr-light-blue">Use one of your saved payment methods or add a new one</p> -->
      @for (card of userAndCardDetails[0]; track card) {
        <ion-item lines="none" class="card-data ion-no-padding">
          <ion-row class="splitter-line-bottom">
            <ion-col size="3"> <img src="../../../assets/icon/visa.svg" class="card-size" alt="visa" /></ion-col>
            <ion-col size="6" class="card-number">**** **** **** {{ card?.card_short_number }}</ion-col>
            <ion-col size="3" class="checkbox-area">
              <ion-checkbox color="secondary" checked></ion-checkbox>
            </ion-col>
          </ion-row>
        </ion-item>
      }
      <h1 class="text-payment-method link-text-blue" (click)="openAddNewCard()">+ {{'existing-card.Add' | translate}}</h1>
      <div class="payable-today-wrapper">
        <p class="payable-today">{{'existing-card.Payable' | translate}}</p>
        <p class="payable-today-amt">£{{ paymentDetails?.total_cost }}</p>
      </div>
      <!-- <ion-button
      (click)="makePayment(paymentDetails, userAndCardDetails[1].get_customer_details.response)"
      size="small "
      expand="block "
      class="pay-btn"
      >Pay now</ion-button -->
      <!-- <ion-button size="small " expand="block" class="pay-btn" (click)="goToViewTicketpage()">Pay now</ion-button> -->
      <p class="arrow-back" (click)="goBack()"><span class="arrow">←</span> {{'existing-card.Back' | translate}}</p>
    }
  </div>
} @else {
  <app-in-progress-animation></app-in-progress-animation>
}
